export default __webpack_public_path__ + "static/media/marker.0592f62c.svg";